const moduleHome = {
	namespaced: true,
	state: {
		PRELOAD_IMGLIST: [],		// 预加载图片
        FULLPAGE: null,		// home 全屏滚动类
        NAVLIST: [
            {
                text: "메인"
            },
			{
				text: "오퍼레이터"
			},
			{
				text: "세계관"
			},
			{
				text: "갤러리"
            },
			{
				text: "코믹"
			},
            {
                text: "교환 코드",
				router_path: "/gift"
            }
        ]
	},
	mutations: {
		SET_PRELOADIMGLIST: (state, params) => {
			state.PRELOADIMGLIST = params
		},
		INIT_FULLPAGE: (state, params) => {
			state.FULLPAGE = params
		},
	},
	actions: {
	},
	getters: {
		NAV_ACTIVE_INDEX: state => {
			if(state.FULLPAGE) {
				return state.FULLPAGE.activeIndex
			} else {
				return -1
			}
		}
	}
}

export default moduleHome
